import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import LocaleWrapper from 'containers/LocaleWrapper/LocaleWrapper.jsx'

import requestSettings from 'state/actions/settings'


export class App extends React.Component {
    static propTypes = {
        loaded: PropTypes.bool.isRequired,

        requestSettings: PropTypes.func.isRequired,
    }
    componentDidMount() {
        this.props.requestSettings()
    }

    render() {
        if (!this.props.loaded) return null

        return (
            <LocaleWrapper>
                {this.props.children}
            </LocaleWrapper>
        )
    }
}

export const mapStateToProps = ({ settings }) => {
    return {
        loaded: settings.loaded,
    }
}

export const mapDispatchToProps = {
    requestSettings,
}

export default connect(mapStateToProps, mapDispatchToProps)(App)



// WEBPACK FOOTER //
// ./containers/App/App.jsx